module.exports = __webpack_public_path__ + "static/media/recojehojasplano.439ae695.jpg";